import { ITaiKhoan } from './TaiKhoan.type';

export interface IBaseList<T = string> {
  label: string;
  value?: T;
  id?: string;
  options?: IBaseList<T>[];
  disabled?: boolean;
}

export interface IBasePagingRes<T> {
  data: T[];
  total: number;
}

export interface IBaseProps {
  children: any;
}

export interface IBaseQuery {
  page?: number;
  // limit?: number;
  take: number;
  cursor?: string;
  search?: string;
  init?: boolean;
}

export enum HttpStatusCode {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  ERROR_SERVER = 500,
  NOT_FOUND = 404,
  BAD_REQUEST = 400,
  SUCCESS = 200,
}

export interface IBaseState<T> {
  loading: boolean;
  total: number;
  data: T[];
  refresh: boolean;
  page: number;
  detail?: T;
  // selected: T[];
  // filterDrawler: boolean;
  // countFilter: number;
}

export interface IBaseConfirmModalParams {
  title?: string;
  content?: string;
  contentHtml?: string;
  onOk: () => Promise<boolean> | boolean;
}

export interface IPropsIcon {
  size?: number;
  color?: string;
}

export interface IBreadcrumb {
  title: string;
  path: string;
}

export interface IBaseResponse<T> {
  [x: string]: any;
  data: T;
  message?: string;
  errors?: IErrorResponse[];
}

export interface IErrorResponse {
  message: string;
  extensions: { code: EErorCode };
}

export enum EErorCode {
  FORBIDDEN = 'FORBIDDEN',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  ECONNABORTED = 'ECONNABORTED',
}

export interface IBaseEntity {
  id: number;
  NgayXoa: string;
  NguoiXoa?: ITaiKhoan;
  idNguoiXoa?: number;
  NgayTao: string;
  NguoiTao?: ITaiKhoan;
  idNguoiTao: number;
  NgayCapNhat: string;
  NguoiCapNhat?: ITaiKhoan;
  idNguoiCapNhat: number;
}

export type TypeStatusColor = 'danger' | 'warning' | 'success' | 'secondary' | undefined;

export interface IDataHasTreeOTM {
  id: string;
  parent_id?: string;
  label?: string;
  children?: string[] | any[];
  name: string;
}
